// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"0e1f44a6","622":"bf487e96"}[chunkId] + ".chunk.js";
};